import validate from "/home/runner/work/onenews/onenews/web-services/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.4.1_@types+node@22.13.1_eslint@9.16.0_jiti@2.4.2__ioredis@5._na3yscz2gc6dsudw2iyjunjjsa/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  redirects: () => import("/home/runner/work/onenews/onenews/web-services/onenews/middleware/redirects.js")
}